/**
 * Desc: 报表项目异常提示.
 */
import style from './normalReportTip.scss';
import React from 'react';

/**
 *          areaVal             某年销售区域大于 40%的指标 || 某年销售产品大于 40%的指标
 *          proportion          公司应收应付款项账龄情况 账款比例大于40%的
 *          customer            前五大客户或者前五大供应商中 占年度销售总额比例大于40%的
 *          title { String } 标题
 */

export default function NormalReportTip({ areaVal, proportion, customer, title, name, year }) {
    return (
        <div className={style.normal}>
            {areaVal && (
                areaVal > 40 ?
                    <p>
                        {year}{name}占比为<span className={style.normalTitle}>{areaVal}</span>%，
                        可能存在财务舞弊或财务风险，建议重点关注。
                    </p> : ''
            )
            }
            {proportion && (
                proportion > 40 ?
                    <p>
                        目标公司三年以上应收账款比例为<span className={style.normalTitle}>
                            {proportion}</span>%，可能存在长期挂账的情况，建议重点关注。
                    </p> : ''
            )
            }
            {customer && (
                customer > 40 ?
                    <p>
                        这五个{title}，{name}占比为<span className={style.normalTitle}>{customer}</span>%，
                        可能存在财务舞弊或财务风险，建议重点关注。
                    </p> : ''
            )
            }
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/normalReportTip/NormalReportTip.jsx